// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1SiFL","log":"ModalInventoryLogs_log__2oHJ_","date":"ModalInventoryLogs_date__28rU1","userName":"ModalInventoryLogs_userName__15S7P"};